import { connect } from 'react-redux'; 
import React, { useEffect, useState } from "react";
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import addDays from "date-fns/addDays";


import Modal from 'react-modal';


    
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};


const Administration = () => {

    async function checkReservations() {
        const response = await fetch('admin?action=checkReservation&month=' + "4" + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        const data = await response.json();
        setReservationData(data);
    }

    async function checkArchive() {
        const response = await fetch('admin?action=checkArchive&sessionToken=' + sessionToken + '&adminname=' + userName);
        const data = await response.json();
        setReservationData(data);
    }

    async function initCheckReservations(initSessionToken: string) {
        const response = await fetch('admin?action=checkReservation&month=' + "4" + '&sessionToken=' + initSessionToken + '&adminname=' + userName);
        const data = await response.json();
        setReservationData(data);
    }

    async function deleteReservation(id: number) {
        const response = await fetch('admin?action=deleteReservation&id=' + id + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        const data = await response.json();
        //setReservationData(data);
        checkReservations();
    }

    async function executePayment() {
        const response = await fetch('admin?action=registerPayment&id=' + payeeID + "&amount=" + payeeAmount + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        setPaymentModalIsOpen(false);
        resetModals()
        checkReservations();
        
    }

    async function executeDepositPayment() {
        const response = await fetch('admin?action=registerDepositPayment&id=' + payeeID + "&amount=" + payeeAmount + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        setDepositModalIsOpen(false);
        resetModals()
        checkReservations();

    }

    async function executeConsumptionRegistration() {
        const response = await fetch('admin?action=registerConsumption&id=' + payeeID + "&amount=" + payeeAmount + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        setConsumptionModalIsOpen(false);
        resetModals()
        checkReservations();
    }

    async function depositReminder(email: string, name: string, title: string, date: string, price: number, address: string) {
        const response = await fetch('reminder?action=depositReminder&email=' + email + "&name=" + name + '&title=' + title + '&date=' + date + '&price=' + price + '&adminname=' + userName + '&sessiontoken=' + sessionToken + '&address=' + address);
        const data = await response.json();
        if (data[0] === "200") {
            alert('Rykker sendt til: ' + email);
        } else {
            alert('Kunne ikke sende rykker til ' + email + ' fejl:' + data[1]);
        }
    }

    async function paymentReminder(email: string, name: string, title: string, date: string, price: number, address:string) {
        const response = await fetch('reminder?action=paymentReminder&email=' + email + "&name=" + name + '&title=' + title + '&date=' + date + '&price=' + price + '&adminname=' + userName + '&sessiontoken=' + sessionToken + '&address=' + address);
        const data = await response.json();
        if (data[0] === "200") {
            alert('Rykker sendt til: ' + email);
        } else {
            alert('Kunne ikke sende rykker til ' + email);
        }
    }

    async function logon() {
        const response = await fetch('login?adminname=' + userName + '&password=' + password);
        const data = await response.json();
        
        if (data[0][0] == "200") {
            setIsLoggedOn(true);
            setSessionToken(data[0][1]);
            initCheckReservations(data[0][1]);
        } else {
            alert('fejl i brugernavn eller kodeord.');
            setUserName("");
            setPassword("");
            setActiveUser("");
        }
    }


    async function archive(id: number) {
        const response = await fetch('admin?action=archiveReservation&id=' + id + '&sessionToken=' + sessionToken + '&adminname=' + userName);
        const data = await response.json();
        checkReservations();
    }


    async function resetPassword() {
        const response = await fetch("AdminPassword?action=reset&username=" + userName);
        const data = await response.json();
        if (data[0] == "200") {
            alert('Aktiveringsmail sendt');
        } else {
            alert('Kunne ikke oprette aktiverings mail.' + data[1]);
        }
    }

    function logoff() {
        setIsLoggedOn(false);
        setActiveUser("");
        setPassword("");
        setUserName("");
    }

    function registerPayment(id: number, name:string, date:string, payment:number) {
        setPayeeID(id);
        setPayeeName(name);
        setPayeeDate(date);
        setPayeeAmount(payment);
        setPaymentModalIsOpen(true);
    }

    function registerDeposit(id: number, name: string, date: string, deposit:number) {
        setPayeeID(id);
        setPayeeName(name);
        setPayeeDate(date);
        setPayeeAmount(deposit);
        setDepositModalIsOpen(true);
    }

    function registerConsumption(id: number, name: string, date: string, consumption:number) {
        setPayeeID(id);
        setPayeeName(name);
        setPayeeDate(date);
        setPayeeAmount(consumption);
        setConsumptionModalIsOpen(true);
    }



    function resetModals() {
        setPayeeID(0);
        setPayeeName("");
        setPayeeDate("");
        setPayeeAmount(0);
        setPaymentModalIsOpen(false);
        setDepositModalIsOpen(false);
        setConsumptionModalIsOpen(false);
    }

    const [activeUser, setActiveUser] = useState("");
    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");
    const [isLoggedOn, setIsLoggedOn] = useState(false);
    const [sessionToken, setSessionToken] = useState("");


    function afterOpenConfirmationModal() {
        // references are now sync'd and can be accessed.
    }

    function closeConfirmationModal() {
        setPaymentModalIsOpen(false);
        setDepositModalIsOpen(false);
        setConsumptionModalIsOpen(false);
    }

    const [payeeID, setPayeeID] = useState(0);
    const [payeeName, setPayeeName] = useState("");
    const [payeeDate, setPayeeDate] = useState("");
    const [payeeAmount, setPayeeAmount] = useState(0);
    const [paymentModalIsOpen, setPaymentModalIsOpen] = useState(false);
    const [depositModalIsOpen, setDepositModalIsOpen] = useState(false);
    const [consumptionModalIsOpen, setConsumptionModalIsOpen] = useState(false);



    var [reservationData, setReservationData] = useState([{ "id": 0, "name": "", "date": "", "phone": "", "title": "", "price": 0, "paid": 0, "depositBalance": 0, "consumption": 0, "email": "", "address": "", "reservationdate": "", "account": "", "regno": "", "eventType": "", "state": "", "timeSlot1": 0, "timeSlot2": 0, "timeSlot3": 0 }]);

    return (
        <div>
            <h1>Administration</h1>

            <Form className="loginForm" hidden={isLoggedOn}>
                <Form.Group controlId="formBasicEmail">
                    <Form.Control type="email" placeholder="email" value={userName} onChange={e=> setUserName(e.target.value)} className="loginField" />
                    </Form.Group>

                <Form.Group controlId="formBasicPassword">
                    <Form.Control type="password" placeholder="Kodeord" value={password} onChange={e => setPassword(e.target.value)} className="loginField" />
                </Form.Group>
                <Button variant="primary" onClick={logon}>Log på</Button>
                &nbsp;&nbsp;&nbsp;
                <Button variant="primary" onClick={resetPassword}>Glemt Kodeord</Button>
                
            </Form>

            <div hidden={!isLoggedOn}>
                <div className="rightAligned">
                    <button
                        className="btn btn-outline-danger"
                        onClick={logoff}>
                        Log af {activeUser}</button>
                </div>
                <div className="leftAligned">
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={checkReservations}>
                        {"Se reservationer"}</button>
                    <button
                        className="btn btn-primary btn-sm"
                        onClick={checkArchive}>
                        {"Arkiv"}</button>
                    <pre> </pre>
                        <p className="missingDeposit">Mgl depositum</p>
                    <pre> </pre>
                        <p className="missingFullPayment">Mgl. fuld betaling</p>
                    
                </div>
                
                
                
                <table className="adminList">
                    <thead>
                        <tr>
                            <th>Dato</th>
                            <th>Reserveret af</th>
                            <th>Vej</th>
                            <th>Pris</th>
                            <th>Betalt</th>
                            <th>Depositum</th>
                            <th>Handlinger</th>
                        </tr>
                    </thead>
                    <tbody>
                        {reservationData.map(data =>
                            <tr hidden={(data.id == 0)} className={data.eventType} >
                            <td>{data.date}</td>
                                <td className={(data.state == "Cancelled") ? "missingDeposit" : ""}>{(data.state != "Cancelled")? data.name : "Ønskes aflyst"}</td>
                            <td>{data.address}</td>
                            <td className={((new Date() > addDays(new Date(data.date), -30) && data.paid < data.price) ? "missingFullPayment" : "")}>{(data.price != 0) ? data.price : ''}</td>
                                <td className={((new Date() > addDays(new Date(data.date), -30) && data.paid < data.price) ? "missingFullPayment" : "")}>{(data.price != 0) ? data.paid : ''}</td>
                                <td className={((new Date() > addDays(new Date(data.reservationdate), 10) && data.price > 1000 && data.depositBalance < ((data.consumption != 0) ? data.consumption : 1000)) ? "missingDeposit" : "")}>{(data.price != 0) ? data.depositBalance : ''}</td>
                                <td>
                                    <div hidden={(data.price == 0 && data.eventType != "Public") || data.state == "Archived"} className="input-group mb-3">
                                        
                                        <DropdownButton id="dropdown-basic-button" title="handlinger">
                                            <Dropdown.Item>=== Administrer betalinger ===</Dropdown.Item>
                                            <Dropdown.Item onClick={() => registerDeposit(data.id, data.name, data.date, data.depositBalance)}>Registrer depositum</Dropdown.Item>
                                            <Dropdown.Item onClick={() => registerPayment(data.id, data.name, data.date, data.paid)}>Registrer betaling</Dropdown.Item>
                                            {/* <Dropdown.Item onClick={() => registerConsumption(data.id, data.name, data.date, data.consumption)}>Registrer forbrug</Dropdown.Item>*/}
                                            <Dropdown.Item>========= Andet =========</Dropdown.Item>
                                            <Dropdown.Item onClick={() => paymentReminder(data.email, data.name, data.title, data.date, (data.price - data.paid), data.address)}>Ryk for betaling af leje</Dropdown.Item>
                                            <Dropdown.Item onClick={() => archive(data.id)}>Arkivér</Dropdown.Item>
                                            <Dropdown.Item onClick={() => alert("Titel: " + data.title + "\nReserveret af: " + data.name + "\neMail: " + data.email + "\nKonto: " + data.account + "\nregno: " + data.regno + "\nTelefon: " + data.phone + "\nAddresse: " + data.address + ((data.timeSlot1 + data.timeSlot2 + data.timeSlot3) < 3 ? "" + (data.timeSlot1 == 1 ? "\nFormiddag" : "") + (data.timeSlot2 == 1 ? "\nEftermiddag" : "") + (data.timeSlot3 == 1 ? "\nAften" : "") : ""))}>Se detaljer</Dropdown.Item>
                                        </DropdownButton>
                                        <button hidden={data.price == 0 && data.eventType != "Public"} className="btn btn-danger btn-sm" onClick={() => { if (window.confirm('Bekræft sletning af ' + data.name + 's reservation?')) deleteReservation(data.id) }}>Slet</button>
                                    </div>
                                    <div hidden={data.state != "Archived"} className="input-group mb-3">
                                        Arkiveret
                                    </div>
                                </td>
                        </tr>
                        )}
                    </tbody>
                </table>

                <Modal
                    isOpen={paymentModalIsOpen}
                    onAfterOpen={afterOpenConfirmationModal}
                    onRequestClose={closeConfirmationModal}
                    style={customStyles}
                    contentLabel="Betaling">
                    <div>
                        <h2>Registrer betaling:</h2>
                        
                        <p>Indtast modtaget beløb fra {payeeName}<br/>
                        Som betaling for reservation d. {payeeDate}</p>
                        <br/>
                        <input placeholder="indbetalt beløb" pattern="[0-9]*" value={payeeAmount} onChange={e => setPayeeAmount(Number(e.target.value))}></input>
                        <button className="btn btn-outline-success btn-sm" onClick={() => executePayment()}>Registrer betaling</button>
                        </div>
                </Modal>

                <Modal
                    isOpen={depositModalIsOpen}
                    onAfterOpen={afterOpenConfirmationModal}
                    onRequestClose={closeConfirmationModal}
                    style={customStyles}
                    contentLabel="Betaling">
                    <div>
                        <h2>Registrer depositum:</h2>

                        <p>Modtaget beløb fra {payeeName}<br />
                        Som depositum for reservation d. {payeeDate}</p>
                        <br />
                        <input pattern="[0-9]*" value={payeeAmount} onChange={e => setPayeeAmount(Number(e.target.value))}></input>
                        <button className="btn btn-outline-success btn-sm" onClick={() => executeDepositPayment()}>Opdater depositum</button>
                    </div>
                </Modal>

                <Modal
                    isOpen={consumptionModalIsOpen}
                    onAfterOpen={afterOpenConfirmationModal}
                    onRequestClose={closeConfirmationModal}
                    style={customStyles}
                    contentLabel="Forbrug">
                    <div>
                        <h2>Registrer forbrug:</h2>

                        <p>Indtast forbrug for {payeeName}'s<br />
                        leje af fælleshuset d. {payeeDate}</p>
                        <br />
                        <input pattern="[0-9]*" value={payeeAmount} onChange={e => setPayeeAmount(Number(e.target.value))}></input>
                        <button className="btn btn-outline-success btn-sm" onClick={() => executeConsumptionRegistration()}>Opgjort forbrug</button>
                    </div>
                </Modal>

            </div>
            </div>
        );
    
};

export default connect()(Administration);


